export const NEWGATEWAY = 'NEWGATEWAY';
export const SHOW_LOADING = 'SHOW_LOADING';
export const UPDATEGATEWAY = 'UPDATEGATEWAY';